import { useQuery } from '@tanstack/react-query';

import { MembershipIdentifier } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership/:membershipId/identifiers/:identifierId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    membershipId: string;
    identifierId: string;
}
const queryFn = ({ parkingId, membershipId, identifierId }: DTO): Promise<MembershipIdentifier> => {
    return axios.get(formatResourcePath(RESOURCE,{ parkingId, membershipId, identifierId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_IDENTIFIER_RESOURCE, useQueryHook as useGetIdentifier };
